import React, { Component } from "react"
import "./userProfilePosts.scss"
import PostCreate from "../../../feed/postCreate"
import PostsList from "../../../feed/postsList"
import { bindActionCreators } from "redux"
import { getData } from "../../../../../library/store/actions/creators/authCreators"
import { getPerson } from "../../../../../library/store/actions/creators/personCreators"
import {
  clearPostsList,
  getPostsList,
} from "../../../../../library/store/actions/creators/postsCreators"
import { connect } from "react-redux"
import { withSnackbar } from "notistack"

class UserProfilePosts extends Component {
  state = {
    userInfo: this.props.userInfo,
    posts: [],
    type:
      parseInt(this.props.match.params.userId) !== this.props.auth.userData.id
        ? "other-profile"
        : "my-profile",
    dataReceived: false,
    id: this.props.userInfo.id,
  }

  setStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve)
    })
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.userId !== prevProps.match.params.userId) {
      const type =
        parseInt(this.props.match.params.userId) !== this.props.auth.userData.id
          ? "other-profile"
          : "my-profile"
      this.setState({ type })
    }
  }

  render() {
    const { userInfo, type } = this.state

    return (
      <div className="posts">
        <PostCreate {...this.props} type={type} userInfo={userInfo} />
        <PostsList {...this.props} type={type} userInfo={userInfo} />
      </div>
    )
  }
}

const mapStateToProps = ({auth, person, posts}) => ({auth, person, posts});
const mapDispatchToProps = dispatch => bindActionCreators({getData, getPerson, getPostsList, clearPostsList}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(UserProfilePosts));
